// extracted by mini-css-extract-plugin
module.exports = {"Page":"DefaultTemplate_Page__ZM87n","Fullscreen":"DefaultTemplate_Fullscreen__z0F4i"};